import { render, staticRenderFns } from "./chateau-clinet.vue?vue&type=template&id=72b9b4ea&scoped=true"
import script from "./chateau-clinet.vue?vue&type=script&lang=js"
export * from "./chateau-clinet.vue?vue&type=script&lang=js"
import style0 from "./chateau-clinet.vue?vue&type=style&index=0&id=72b9b4ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b9b4ea",
  null
  
)

export default component.exports